import { BaseStagePlugin } from './base-stage-plugin';

export const BaseViewportPlugin = BaseStagePlugin;

BaseViewportPlugin.displayName = 'BaseViewportPlugin';
